import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-262b1c30"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-2 d-flex align-items-center" }
const _hoisted_4 = { class: "col-3 d-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "row mt-5" }
const _hoisted_7 = { class: "col-3 d-flex align-items-center" }
const _hoisted_8 = { class: "col-3 d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "row mt-5" }
const _hoisted_11 = { class: "col-3 d-flex align-items-center" }
const _hoisted_12 = { class: "col-3 d-flex align-items-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { class: "row mt-5" }
const _hoisted_15 = { class: "col-8 d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = { class: "row mt-5" }
const _hoisted_18 = { class: "col-3 d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = { class: "mt-5 row pb-5" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, null, -1))
const _hoisted_22 = { class: "col-2 d-flex justify-content-end" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_TaiKhoanSelection = _resolveComponent("TaiKhoanSelection")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageRowLayout = _resolveComponent("PageRowLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationDialog, {
      isDisplay: _ctx.isConfirmationDialogOpen,
      title: "Bạn có chắc hoàn tất tạo mới hợp đồng?",
      center: "",
      onOnCloseButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isConfirmationDialogOpen = false)),
      onOnConfirmButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit()))
    }, null, 8, ["isDisplay"]),
    _createVNode(_component_PageRowLayout, null, {
      "page-row-header": _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.isCreating ? "Tạo mới" : "Chỉnh sửa"), 1)
      ]),
      "page-row-action-button": _withCtx(() => [
        _createVNode(_component_ButtonCustom, {
          "button-type": _ctx.ButtonsType.BACK,
          onClick: _ctx.goBack
        }, null, 8, ["button-type", "onClick"])
      ]),
      "page-row-content": _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "formRef",
          class: "form",
          model: _ctx.contract,
          rules: _ctx.validationRules,
          onSubmit: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.onOpenConfirmationDialog()), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_TaiKhoanSelection, {
              label: "Thông tin tài khoản:",
              labelClasses: "justify-content-start fw-bolder",
              labelCols: 2,
              inputsCols: 5,
              "ma-tai-khoan-prop": _ctx.contract.accountId,
              "ma-chi-tiet-prop": _ctx.contract.taxNumber,
              onOnSelect: _ctx.onSelectedAccountSuccessHandler
            }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "onOnSelect"]),
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, [
                _createVNode(_component_LabelCustom, {
                  "is-bolder": true,
                  "is-required": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Nhập số hợp đồng:")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form_item, {
                  prop: "contractNumber",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.contract.contractNumber,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.contract.contractNumber) = $event)),
                      placeholder: "Nhập số hợp đồng",
                      name: "contractNumber",
                      onFocus: _cache[3] || (_cache[3] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_DivCol, { class: "d-flex" }, {
                default: _withCtx(() => [
                  _createVNode(_component_LabelCustom, {
                    "is-bolder": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Loại HĐ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DivCol, { cols: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "loại_hop_dong",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.contract.loai_hop_dong,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.contract.loai_hop_dong) = $event)),
                        disabled: _ctx.contract.bien_ban_kiem_nghiem.length > 0,
                        class: "w-100",
                        name: "loai_hop_dong"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loaiHopDongOptions, (type) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: type.value,
                              label: type.label,
                              value: type.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LabelCustom, {
                    "is-bolder": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ngày ký hợp đồng: ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_el_form_item, {
                  prop: "signDate",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "w-100",
                      placeholder: "Chọn ngày",
                      name: "signDate",
                      format: "DD/MM/YYYY",
                      modelValue: _ctx.contract.signDate,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.contract.signDate) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LabelCustom, {
                    "is-bolder": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ngày hết hạn hợp đồng: ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_form_item, {
                  prop: "expiryDate",
                  class: "mb-0 w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      class: "w-100",
                      placeholder: "Chọn ngày",
                      modelValue: _ctx.contract.expiryDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contract.expiryDate) = $event)),
                      name: "expiryDate",
                      format: "DD/MM/YYYY"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LabelCustom, {
                    "is-bolder": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Tên đối tác: ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_form_item, {
                  prop: "partnerName",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.contract.partnerName,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.contract.partnerName) = $event)),
                      placeholder: "Nhập tên",
                      name: "partnerName",
                      onFocus: _cache[8] || (_cache[8] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Số điện thoại: ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_el_form_item, {
                  prop: "phoneNumber",
                  class: "mb-0 w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.contract.phoneNumber,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.contract.phoneNumber) = $event)),
                      placeholder: "Số điện thoại",
                      name: "phoneNumber",
                      onFocus: _cache[10] || (_cache[10] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_DivCol, { cols: 2 }, {
                default: _withCtx(() => [
                  _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Địa chỉ: ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_form_item, {
                  prop: "address",
                  class: "mb-0 w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.contract.address,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.contract.address) = $event)),
                      rows: 3,
                      type: "textarea",
                      placeholder: "Địa chỉ",
                      name: "address",
                      onFocus: _cache[12] || (_cache[12] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_LabelCustom, {
                    "is-bolder": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Mã số thuế ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_el_form_item, {
                  prop: "taxNumber",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.contract.taxNumber,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.contract.taxNumber) = $event)),
                      placeholder: "Nhập mã số thuế",
                      name: "taxNumber",
                      onFocus: _cache[14] || (_cache[14] = ($event: any) => ($event.target.select()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_19,
            _createVNode(_component_DivRow, null, {
              default: _withCtx(() => [
                _createVNode(_component_DivCol, {
                  cols: 2,
                  class: "d-flex"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_LabelCustom, { "is-bolder": true }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Số hoá đơn: ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DivCol, { cols: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      prop: "so_hoa_don",
                      class: "mb-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.contract.so_hoa_don,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.contract.so_hoa_don) = $event)),
                          name: "so_hoaDon",
                          onFocus: _cache[16] || (_cache[16] = ($event: any) => ($event.target.select()))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_ButtonCustom, {
                  "color-type": _ctx.ButtonTypeColors.DANGER,
                  "button-type": _ctx.ButtonsType.TRASH,
                  onClick: _withModifiers(_ctx.resetForm, ["prevent"])
                }, null, 8, ["color-type", "button-type", "onClick"]),
                _createVNode(_component_ButtonCustom, {
                  type: _ctx.ButtonTypes.SUBMIT,
                  "button-type": _ctx.ButtonsType.SAVE,
                  "color-type": _ctx.ButtonTypeColors.SUCCESS
                }, null, 8, ["type", "button-type", "color-type"])
              ]),
              _hoisted_23
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    })
  ], 64))
}